/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} One_Item_SelectedInputs */

const en_one_item_selected = /** @type {(inputs: One_Item_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 item selected`)
};

const nl_one_item_selected = /** @type {(inputs: One_Item_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 item geselecteerd`)
};

/**
* | output |
* | --- |
* | "1 item selected" |
*
* @param {One_Item_SelectedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const one_item_selected = /** @type {((inputs?: One_Item_SelectedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<One_Item_SelectedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_one_item_selected(inputs)
	return en_one_item_selected(inputs)
});